import API from '.';

export default class EPSBusinessLine {
  /**
   * The epsbusinessline dimension table for UDM
   * @param {number} eps_business_line_id Id of the epsBusinessLine.
   * @param {string} short_description Name of the epsBusinessLine.
   * @param {string} long_description Description of the epsBusinessLine.
   * @param {number} eps_business_vc_id
   */
  constructor({
    eps_business_line_id,
    short_description,
    long_description,
    eps_business_vc_id,
  }) {
    this.eps_business_line_id = eps_business_line_id;
    this.short_description = short_description;
    this.long_description = long_description;
    this.eps_business_vc_id = eps_business_vc_id;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get('/epsBusinessLine');
    return data.map((d) => new EPSBusinessLine(d));
  }

  static async get(id) {
    const api = await API();
    const { data } = await api.get(`epsBusinessLine/${id}`);
    return new EPSBusinessLine(data);
  }

  // static async create(data) {
  //   const api = await API();
  //   console.log(data);
  //   const { res } = await api.post('epsBusinessValueChain', data);
  //   return res;
  // }

  // static async update (id, data) {
  //   const api = await API();
  //   const { res } = await api.put(`/epsBusinessValueChain`, data);
  //   return res;
  // }
}
